<template>
  <div>中文 </div>
</template>

<script>
export default {
}
</script>

<style>

</style>